import { AWS_URL } from '../constants/url'

export const getImageUrl = (file) => {
    const url = `${AWS_URL}/${file.Key}`

    return url
}